<template>
  <table
    ref="table"
    class="table-hover reports-table time-off-transactions-report-table table"
  >
    <TimeOffTransactionsReportTableHeader />

    <!-- eslint-disable vue/require-v-for-key -->
    <template v-for="section in tableData.sections">
      <tbody class="grouping-header">
        <tr v-if="baseColCount">
          <th>
            {{ section.main }}
          </th>
          <th
            v-for="col in colCount"
            :key="col"
          ></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </tbody>

      <tbody class="tbody">
        <tr
          v-for="(row, index) in section.rows"
          :key="index"
        >
          <td v-if="walker.sub_show">
            <template v-if="row.sub_show_data">
              {{ row.record.sub }}
            </template>
          </td>
          <td v-if="walker.third_show">
            <template v-if="row.third_show_data">
              {{ row.record.third | formatDate }}
            </template>
          </td>
          <td>
            {{ row.record.starts_at | formatDate }}
          </td>
          <td>
            {{ row.record.ends_at | formatDate }}
          </td>
          <td class="text-clip-cell">
            <span
              v-if="row.record.adjustment_type_report_label"
              class="adjustment_type_label"
              :class="adjustmentTypeClass(row.record)"
            >
              {{ row.record.adjustment_type_report_label }}
            </span>
          </td>
          <td class="long-text-cell">
            <div
              :key="popoverKey"
              v-popover:[popoverPlacement]
              class="long-text"
              :data-content="row.record.reason"
            >
              {{ row.record.reason }}
            </div>
          </td>
          <td>
            <span
              v-tooltip
              :title="row.record.approved_at | formatDateTime"
            >
              {{ row.record.approved_by_name }}
            </span>
          </td>
          <td>{{ row.record.created_by_name }}</td>
          <td>
            <template v-if="row.aggregate">
              <b>
                {{ row.aggregate.amount | formatDuration(false, '-', false, true) }}
              </b>
            </template>
            <template v-else>
              {{ row.record.amount | formatDuration(false, '-', false, true) }}
            </template>
          </td>
        </tr>
      </tbody>
      <tbody class="tfoot">
        <tr>
          <th>Total</th>
          <td v-if="walker.sub_show"></td>
          <td v-if="walker.third_show"></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td data-title="Total">
            {{ section.total.amount | formatDuration(false, '-', false, true) }}
          </td>
        </tr>
      </tbody>
    </template>
    <!-- eslint-enable vue/require-v-for-key -->
  </table>
</template>

<script>
import { mapGetters } from 'vuex';
import TimeOffTransactionsReportTableHeader from './TimeOffTransactionsReportTableHeader.vue';
import { throttle } from 'lodash-es';

export default {
  name: 'TimeOffTransactionsReportTable',
  components: { TimeOffTransactionsReportTableHeader },
  props: {
    tableData: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    parentTable: null,
    popoverKey: 0,
  }),
  computed: {
    ...mapGetters(['walker', 'tableIsTeam']),
    types() {
      return [
        'starting_balance',
        'starting_balance_no_rollover',
        'accrual',
        'annual_accrual',
        'time_off',
        'manual_adjustment',
        'joined_date_accrual',
      ];
    },
    baseColCount() {
      return this.walker.base_column_count;
    },
    colCount() {
      if (this.tableIsTeam) {
        return this.baseColCount + 1;
      }

      return this.baseColCount;
    },
    isMobile() {
      return document.body.classList.contains('touch');
    },
    popoverPlacement() {
      return this.isMobile ? 'top' : 'left';
    },
  },
  mounted() {
    this.parentTable = this.isMobile ? this.$refs.table.parentNode : null;

    if (this.parentTable) {
      this.parentTable.addEventListener('scroll', this.onScroll);
    }
  },
  beforeDestroy() {
    if (this.parentTable) {
      this.parentTable.removeEventListener('scroll', this.onScroll);
    }
  },
  methods: {
    adjustmentTypeClass(record) {
      return `adjustment_type-${record.adjustment_type_short_name}`;
    },
    onScroll: throttle(function () {
      this.$el.querySelectorAll('.popover.in').forEach((el) => {
        $(el).popover('hide');

        this.popoverKey++;
      });
    }, 100),
  },
};
</script>
